import styled from 'styled-components'
export const PreferenceWrapper = styled.div`
  /* padding-top: 23px; */
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  .title {
    color: ${({ theme }) => theme.colors.navyBlue};
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-size: ${({ theme }) => theme.fontSize.xl};
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.DarkCyan};
    margin-top: 10px;
  }
  p {
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x5};
    line-height: 24px;
    color: ${({ theme }) => theme.colors.dark};
    opacity: 0.8;
  }
  .box {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #858c94;
    border-radius: 8px;
    margin-bottom: 20px;
    padding-left: 16px;
  }
  .cancel {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.CollaboBlue};
    border: 1px solid ${({ theme }) => theme.colors.CollaboBlue};
    margin-top: 20px;
  }
  .cards {
    overflow-y: scroll;
    height: 430px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    ::-webkit-scrollbar {
      display: none;
    }
  }
`
